










import { Component, Prop, Vue as VueDecorator, Watch } from "vue-property-decorator";

import { getImageUrl, getSharedImageUrl } from "@/data/repository/FirebaseImageRepository";

@Component
export default class FirestoreImageComponent extends VueDecorator {
  @Prop()
  imageRef!: string;

  @Prop()
  isMemberClient!: string;

  imageUrl = "";

  didLoadImageUrl = false;

  @Watch("imageRef")
  onImageRefChanged() {
    this.tryFetchingImage();
  }

  async tryFetchingImage() {
    try {
      const imageUrl = this.isMemberClient
        ? await getSharedImageUrl(this.imageRef)
        : await getImageUrl(this.imageRef);

      if (imageUrl) {
        this.imageUrl = imageUrl;
        this.didLoadImageUrl = true;
      }
    }
    catch {
      // Skip
    }
  }

  async created() {
    this.tryFetchingImage();
  }

  hashRef(ref: string) {
    let hash = 0;

    if (ref.length == 0) {
      return hash.toString();
    }

    for (let i = 0; i < ref.length; i++) {
      const char = ref.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash;
    }

    return hash.toString();
  }
}
